import * as api from '../_api';

export const ceoReadTraining = async ({ commit, dispatch }, { trainingId, ceoId }) => {
  try {
    const result = await api.ceoReadTraining(trainingId, ceoId);
    commit('setTraining', result.training);
    commit('setCompanyGuests', result.savedGuests);
    commit('setTrainingGuests', result.trainingGuests);
    commit('setCeo', result.ceo);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const ceoRemoveGuest = async ({ commit, dispatch }, { trainingId, guestId }) => {
  try {
    await api.ceoRemoveGuest(trainingId, guestId);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const ceoAddGuests = async ({ commit, dispatch }, { trainingId, ceoId, guests }) => {
  try {
    await api.ceoAddGuests(trainingId, ceoId, guests);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const ceoCreateGuest = async ({ commit, dispatch }, { guest, training }) => {
  try {
    await api.ceoCreateGuest(training.id, guest.company, guest);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const hostReadEvent = async ({ commit, dispatch }, { eventId, guestId }) => {
  try {
    const result = await api.hostReadEvent(eventId, guestId);
    commit('setEvent', result);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// export const updateEventInvitation = async ({ commit, dispatch }, { eventId, guestId, guest }) => {
//   try {
//     await api.updateEventInvitation(eventId, guestId, guest);
//     return true;
//   } catch (err) {
//     dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
//     return false;
//   }
// };
